import SpaSection from './SpaSection';

export default SpaSection;
